import * as React from 'react';
import { useRagnar } from '@mentimeter/ragnar-react';
import { isThemeColor } from '@mentimeter/ragnar-dsc';
import { Svg } from '../svg';
import type { IllustrationsWrapperT } from './types';

export const IllustrationsWrapper = ({
  userColor,
  color = 'text',
  'aria-hidden': ariaHidden = true,
  'aria-label': ariaLabel,
  children,
  viewBox,
}: IllustrationsWrapperT) => {
  const { theme } = useRagnar();
  return (
    <Svg
      viewBox={viewBox}
      fillRule="evenodd"
      clipRule="evenodd"
      aria-hidden={ariaHidden}
      aria-label={ariaLabel}
      fill={
        userColor
          ? userColor
          : isThemeColor(theme, color)
            ? theme.colors[color]
            : color
      }
    >
      {children}
    </Svg>
  );
};
